export enum DartsGameType {
    LEAGUE = 0,
    KNOCKOUT = 1,
    SHOOTOUT = 2,
    STANDALONE = 3,
    TEST = 4
}

export type DartsGameTypes =
    DartsGameType.LEAGUE |
    DartsGameType.KNOCKOUT |
    DartsGameType.SHOOTOUT |
    DartsGameType.STANDALONE |
    DartsGameType.TEST;